export default {
  dropHint: "将图片拖放到任意位置",
  dragDropHint: "将图片拖放到这里或点击上传",
  dropzoneHint: {
    pointer: "将图片拖放到这里或点击上传",
    touch: "点击选择照片"
  },
  reuploadHint: "原图已就绪，点击可重新上传",
  reuploadAction: "重新上传",
  originalReadyPreview: "原图已上传",
  originalPreviewAlt: "已上传原图预览",
  originalPreviewFallback: "暂时无法显示原图预览",
  limitText: "小于30MB",
  compressing: {
    title: "正在压缩图片",
    message: "图片较大，正在压缩处理，请稍候…",
  },
  loginResume: {
    loadingTitle: "正在恢复分析",
    loadingMessage: "正在恢复你上次未完成的图片分析，请稍候…",
    failedTitle: "无法恢复上次的分析",
    failedMessage: "未找到上次未完成的记录，请重新上传图片。",
    missingImageMessage: "本地图片缓存已失效，请重新上传该图片。",
  },
  step: {
    uploadOriginal: "上传你的照片",
    selectPreset: "选择参考风格图",
  },
  preset: {
    title: "步骤 2：选择参考风格图",
    description: "请选择一个预设风格作为本次后期目标。",
    empty: "参考风格库暂不可用，请稍后再试",
    reload: "重新加载参考库",
    imageLoadError: "资源加载失败",
    categoryTitle: "风格分类",
    categoryAll: "全部",
    categoryFeatured: "精选",
    featuredBadge: "精选",
    lightboxAriaLabel: "放大查看参考风格图",
  },
  action: {
    startAnalysis: "开始分析",
    skipPreset: "跳过参考图进入兼容模式",
  },
  error: {
    invalidType: {
      title: "文件类型错误",
      message: "请上传图片文件",
    },
    tooLarge: {
      title: "文件过大",
      message: "图片大小不能超过30MB",
    },
    folderDropped: {
      title: "不支持文件夹",
      message: "请拖入单张图片文件，不支持文件夹。",
    },
    nonFileDropped: {
      title: "不支持的内容",
      message: "请拖入图片文件，链接或文字无法上传。",
    },
    emptyFile: {
      title: "未获取到文件",
      message: "没有拿到可读取的图片文件，请重新选择一张图片。",
    },
    readFailed: {
      title: "图片读取失败",
      message: "无法读取该图片，请重新从本机相册或文件管理器中选择，或换一张图片重试。",
    },
    presetRequired: {
      title: "请选择参考风格图",
      message: "进入分析前请先选择一个参考风格图。",
    },
    invalidPreset: {
      title: "参考风格不可用",
      message: "当前选择的参考风格无效，请重新选择。",
    },
    historyQuotaExceeded: {
      title: "历史配额已满",
      message: "当前历史记录额度已达上限，请清理历史记录或稍后重试。",
    },
    paymentPending: {
      title: "支付仍在确认中",
      message: "系统正在同步支付结果，请稍候重试开始分析。",
    },
    relationSaveFailed: {
      title: "分析任务初始化失败",
      message: "原图任务关系保存失败，请稍后重试。",
    },
  },
};
